import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#0080AA",
        secondary: "#00A8E1",
        accent: "#8C9EFF",
        error: "#EA0C0C",
        // anchor, info, success, warning left unchanged
      },
    },
    options: {
      customProperties: true,
    },
  },
  icons: {
    iconfont: "md",
  },
});
